import { apiSlice as api } from "@/store/rtk-api/apiSlice"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTenant: builder.query<GetTenantResponse, void>({
      query: () => ({
        url: `/v1/tenant`,
        method: "get",
      }),
      providesTags: ["GetTenant"],
    }),
    updateTenant: builder.mutation<UpdateTenantResponse, UpdateTenantSchema>({
      query: (data) => ({
        url: `/v1/tenant`,
        method: "patch",
        data,
      }),
      invalidatesTags: ["GetTenant"],
    }),
  }),
})

export const { useGetTenantQuery, useUpdateTenantMutation } = injectedRtkApi

export default injectedRtkApi

export interface GetTenantResponse {
  success: boolean
  tenant: Tenant
}
export interface Tenant {
  name: string
  csrdReportingBalance: boolean
  csrdReportingTurnover: boolean
  csrdReportingEmployees: boolean
  csrdReportingMarketListed: boolean
  headquarteredOutsideEU: boolean
  reportingEUTurnover: boolean
  reportingNetTurnover: boolean
  reportingEUSubsidiary: boolean
  baseYear: number
  baseYearEmissions: number
  baseYearFile?: string | null
  reportingYear?: number
  hasSubsidiary: boolean
  hasIncorporatedJointVenture: boolean
  hasAffiliated: boolean
  hasNonIncorporatedJointVenture: boolean
  isFranchisor: boolean
  isMultinational: boolean
  inMultipleJurisdictions: boolean
}
export interface UpdateTenantSchema {
  name?: string
  csrdReportingBalance?: boolean
  csrdReportingTurnover?: boolean
  csrdReportingEmployees?: boolean
  csrdReportingMarketListed?: boolean
  headquarteredOutsideEU?: boolean
  reportingEUTurnover?: boolean
  reportingNetTurnover?: boolean
  reportingEUSubsidiary?: boolean
  baseYear?: number
  baseYearEmissions?: number
  baseYearFile?: string | null
  reportingYear?: number
  hasSubsidiary?: boolean
  hasIncorporatedJointVenture?: boolean
  hasAffiliated?: boolean
  hasNonIncorporatedJointVenture?: boolean
  isFranchisor?: boolean
  isMultinational?: boolean
  inMultipleJurisdictions?: boolean
}
export interface UpdateTenantResponse {
  success: boolean
  error: string
}
